module.exports = __webpack_public_path__ + "img/agency-slide-02.15c57d96.jpg";